import * as axios from 'axios';
import { URL_HASH_TAGS } from '../lib/constants';

export const getShortShareLink = async (shareToken) => {

  // Ending '/' in the url is important and needed, as we grab token from between "share-token=" to the next "/".
  // With this, we could have multiple items in the hash.

  /*
    #NOTE: %23 in the url below is #
    -- KD - August 05, 2020
  */

  const pageLinkHost = (process.env.REACT_APP_FIREBASE_PROJECT_ID.indexOf('staging') === -1) ? 'https://gohunt.page.link' : 'https://gohuntstaging.page.link';
  const longDynamicLink =
    `${pageLinkHost}/?` +
    'ibi=com.gohunt.mobile&' +
    'isi=1500630352&' +
    'imv=12.0&' +
    'apn=com.gohunt&' +
    'afl=https://www.gohunt.com/maps&' +
    'ifl=https://www.gohunt.com/maps&' +
    'st=Join+the+Movement&' +
    'sd=goHUNT+Maps+App&' +
    'si=https://www.gohunt.com/sites/all/themes/gohunt/img/insider/FreeTrial_mobile_header.jpg&' +
    'utm_campaign=goHUNT&' +
    `link=${location.origin}/maps/%23${URL_HASH_TAGS.SHARE_TAG.begin}${shareToken}${URL_HASH_TAGS.SHARE_TAG.end}`;

  // const linkText = `http://www.green.gohunt.com:8081/maps/#${URL_HASH_TAGS.SHARE_TAG.begin}${shareToken}${URL_HASH_TAGS.SHARE_TAG.end}`;


  /*
    #TODO: Move googleapis request calls into a lib once we start relying more on it
    -- KD - August 07, 2020
  */
  return axios({
    method: 'POST',
    url: `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${process.env.REACT_APP_FIREBASE_API_KEY}`,
    data: {
      longDynamicLink,
      suffix: {
        option: 'SHORT',
      }
    }
  })
  .then((response) => {
    return {
      success: true,
      data: response.data
    };
  })
  .catch((error) => {
    return { success: false, data: error };
  });
};